import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface RejectionQueryMessagesState {
  words: any[]
  rejectionWordsError: any
  rejectionWordsSuccess: any
}

export const useRejectionQueryMessagesStore = defineStore('rejectionQueryMessages', {
  state: (): RejectionQueryMessagesState => ({
    words: [],
    rejectionWordsError: null,
    rejectionWordsSuccess: null,
  }),

  getters: {
    getRejectionQueryWords: (state) => state.words,
    getRejectionQueryTransactionSuccess: (state) => state.rejectionWordsSuccess,
    geRejectionTransactionError: (state) => state.rejectionWordsError,
  },

  actions: {
    async fetchQueryRejectionWords() {
      try {
        const response = await api().get('/configuration/appeal-message/all')
        this.words = response.data
      } catch (error: any) {
        this.rejectionWordsError = error.response?.data
      }
    },

    async addRejectionQueryWord(data: any) {
      try {
        const response = await api().post('/configuration/appeal-message/create/', data)
        this.rejectionWordsSuccess = response.data
      } catch (error: any) {
        this.rejectionWordsError = error.response?.data
      }
    },

    async editRejectionQueryWord(data: any) {
      try {
        const response = await api().post('/configuration/appeal-message/edit', data)
        this.rejectionWordsSuccess = response.data
      } catch (error: any) {
        this.rejectionWordsError = error.response?.data
      }
    },

    async deleteRejectionQueryWord(data: any) {
      try {
        const response = await api().get('/configuration/appeal-message/delete/' + data.id, data)
        this.rejectionWordsSuccess = response.data
      } catch (error: any) {
        this.rejectionWordsError = error.message
      }
    },
  },
})
